import React from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Defecation from './Defecation';
import { isInitDefecationSelector } from './Defecation/selector';
import { refreshDefecationList } from './Defecation/thunk';
import Drug from './Drug';
import { isInitDrugSelector } from './Drug/selector';
import { refreshDrugList } from './Drug/thunk';
import Meal from './Meal';
import { isInitMealSelector } from './Meal/selector';
import { refreshMealList } from './Meal/thunk';
import Milk from './Milk';
import { isInitMilkSelector } from './Milk/selector';
import { refreshMilkList } from './Milk/thunk';
import Sleep from './Sleep';
import { isInitSleepSelector } from './Sleep/selector';
import { refreshSleepList } from './Sleep/thunk';
import Temperature from './Temperature';
import { isInitTemperatureSelector } from './Temperature/selector';
import { refreshTemperatureList } from './Temperature/thunk';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const HealthRecordCategory: React.FC<Props> = ({
  user,
  child,
  facilityList,
}) => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = React.useState(0);
  const tabs = ['検温', '睡眠', '排泄', 'ミルク', '食事', '薬'];
  const isInitTemperature = useSelector(isInitTemperatureSelector);
  const isInitDefecation = useSelector(isInitDefecationSelector);
  const isInitSleep = useSelector(isInitSleepSelector);
  const isInitMilk = useSelector(isInitMilkSelector);
  const isInitMeal = useSelector(isInitMealSelector);
  const isInitDrug = useSelector(isInitDrugSelector);
  React.useEffect(() => {
    if (!isInitDefecation) {
      dispatch(refreshDefecationList());
    }
    if (!isInitTemperature) {
      dispatch(refreshTemperatureList());
    }
    if (!isInitSleep) {
      dispatch(refreshSleepList());
    }
    if (!isInitMilk) {
      dispatch(refreshMilkList());
    }
    if (!isInitMeal) {
      dispatch(refreshMealList());
    }
    if (!isInitDrug) {
      dispatch(refreshDrugList());
    }
  }, [
    dispatch,
    isInitDefecation,
    isInitTemperature,
    isInitSleep,
    isInitMeal,
    isInitDrug,
    isInitMilk,
  ]);
  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '10px' }}>
        <Tabs
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          value={tabIndex}
          onChange={(_event: React.SyntheticEvent, index: number) => {
            setTabIndex(index);
          }}
        >
          {tabs.map((label) => (
            <Tab label={label} key={label} />
          ))}
        </Tabs>
      </Box>
      {tabIndex === 0 && (
        <Temperature child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 1 && (
        <Sleep child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 2 && (
        <Defecation child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 3 && (
        <Milk child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 4 && (
        <Meal child={child} user={user} facilityList={facilityList} />
      )}
      {tabIndex === 5 && (
        <Drug child={child} user={user} facilityList={facilityList} />
      )}
    </div>
  );
};

export default HealthRecordCategory;
